import { VerticalMenu } from '../menus/vertical/VerticalMenu';
import React from 'react';
import { PageLayout } from '../../pages/PageLayout';
import { Container } from '@mui/material';
import SectionedLayout from './SectionedLayout';
import PropTypes from 'prop-types';

/** @component
 *  Container for the desktop layout.
 *
 *  This component breaks children into "sections", where each section represents
 *  a view on the app page. Currently, we have two of these, the first is effectively
 *  the entirety of the basic app page, whereas the second is the skills drilldown section
 *  within the pro page.
 * @param children
 * @returns {Element}
 * @constructor
 */
const DesktopLayout = ({ children }) => {
    return (
        <PageLayout>
            <VerticalMenu />
            <Container
                sx={{
                    paddingRight: { xs: 0, sm: 11 },
                    paddingLeft: { xs: 0, sm: 4 },
                    marginTop: { xs: 10, sm: 9 },
                    marginBottom: { xs: 10, sm: 9 }
                }}
                style={{
                    minHeight: '85vh',
                    maxWidth: '1300px'
                }}
            >
                <SectionedLayout>{children}</SectionedLayout>
            </Container>
        </PageLayout>
    );
};

DesktopLayout.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
};

export default DesktopLayout;
